import styles from "./Navbar.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { AuthContext } from "../../services/Auth";

import {
  Menu,
  MenuItem,
  MenuButton,
  MenuDivider,
  // SubMenu,
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { Link } from "react-router-dom";
import logoImage from "../../assets/logo-no-background.png";

function Navbar() {
  const { user, logout } = useContext(AuthContext);

  if (!user) return "Carregando...";

  return (
    <>
      <div className={styles.navbar}>
        <div className={styles.navbarContainer}>
          <div className={styles.logo}>
            <Link to="/sgr">
              <img className={styles.logoImage} src={logoImage} alt="logo" />
            </Link>
          </div>
          <div className={styles.itens}>
            <Menu
              menuButton={
                <MenuButton className={styles.menuBtn}>
                  <FontAwesomeIcon icon={faBars} />
                </MenuButton>
              }
              transition={false}
            >
              <MenuDivider />
              {user.projetos
                .sort((a, b) =>
                  a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0
                )
                .map((nome, index) => (
                  <Link key={index} to={nome}>
                    <MenuItem className={styles.menuItem}>{nome}</MenuItem>
                  </Link> 
                ))}
              <MenuDivider />
              <MenuItem onClick={logout}>Sair</MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
